const state = {
    username: "",
    password: ""
}

export default state